
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";
import EstadoTarea  from "components/EstadoTarea";


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TareaEst extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    promedio_tareas:0,
    data: [],/* lista  */
    data2:[],
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    //this.setState({data:[]});
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_data=()=>{
    console.log("cargar_data")
    let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    /*let periodo = this.props.store.user.periodo;*/

    let param = { 
      id_est: id_est,
      id_mate: id_mate,
      id_peri: id_peri,
    }
    console.log(param)
    axios2.post("tarea_est_get_list", param)
    .then(res => {
        console.log(res.data.collection)
        //console.log()
        let tam = res.data.collection.length
        if( tam >0){ 
            this.setState({ data: res.data.collection });
            //this.setState({ data2: res.data.collection2 });
            //this.setState({ promedio_tareas: res.data.promedio_tareas });
        }else{
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  //------------------------------
  render() {
    return(
      <section className="container">
        <NotificationContainer/>

        <div className="row">
          {
            //JSON.stringify(this.state.data )
          }
          {/*<!-- /.col -->*/}
          <div className="col-md-12">
            <div className="box box-primary">
              <div className="box-header with-border">
                <h3 className="box-title">Lista de tareas: { this.state.nom_mate }</h3>

                <div className="box-tools pull-right">

                </div>
                {/*<!-- /.box-tools -->*/}
              </div>
              {/*<!-- /.box-header -->*/}
              <div className="box-body " style={{width: '100%' }}>

                <div className="table-responsive ">
                  <table className="table table-hover table-striped" >
                    <tr>
                      <th></th>
                      <th>Titulo</th>
                      <th>Fecha entrega</th>
                      <th>Estado</th>
                      <th>Acción</th>
                    </tr>
                    <tbody>
                    {this.state.data.map((item,index) => ( 
                      <tr key={index}>
                        <td>
                          <div className="icheckbox_flat-blue" style={{ position: 'relative' }}>
                          
                          </div>
                        </td>
                         <td className="mailbox-subject">{ item.titulo}  </td>
                         <td className="">{ item.fecha_fin } </td>
                         <td className="">
                          <EstadoTarea
                            value={ item.filename }
                          />
                        </td>
                        <td>
                          <Link to={`/tarea_est_nuevo/${item.id_tarea} `} 
                                type="button" 
                                className="btn btn-sm btn-primary">Ver</Link>
                        </td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                  {/*<!-- /.table -->*/}
                </div>
                {/*<!-- /.mail-box-messages -->*/}
              </div>
              {/*<!-- /.box-body -->*/}
              <div className="box-footer no-padding">

              </div>
            </div>
            {/*<!-- /. box -->*/}
          </div>
          {/*<!-- /.col -->*/}
        </div>
        {/*<!-- /.row -->*/}
      </section>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TareaEst);